import { Link, useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';

import { ROUTES } from '#/config/routes';
import { fetchWorkOrderDetail } from '#/api/momMgmt/workOrder/fetchDetail';
import { Button } from '#/modules/commonComponents/button';
import PageShell from '#/modules/infra/layout/PageShell';
import { getWorkOrderApiErrorMessage } from '#/modules/momMgmt/workOrder/helper/apiError';
import { workOrderDetailQueryKey } from '#/utils/queryKeys';

import WorkOrderInboundShell from '../components/WorkOrderInboundShell';

const WorkOrderInboundPage = () => {
  const { id, receiptId } = useParams();
  const isEdit = Boolean(receiptId);

  const detailQuery = useQuery({
    queryKey: workOrderDetailQueryKey(id),
    queryFn: () => fetchWorkOrderDetail(id),
    enabled: Boolean(id),
  });

  const detail = detailQuery.data?.data;
  const isLoading = detailQuery.isLoading;
  const isError = detailQuery.isError;

  return (
    <PageShell variant="formTall">
      <div className="layout-shell__body">
        <div className="mx-auto w-full max-w-6xl">
          <div className="create_edit_page__header">
            <h1 className="page_title mb-0!">
              <span className="border-l-5 border-primary-400 pl-2.5">
                {isEdit ? '編輯入庫單' : '新建入庫單'}
              </span>
            </h1>
            <div className="flex flex-wrap gap-2">
              <Button type="button" variant="outline" asChild>
                <Link to={ROUTES.workOrder}>返回列表</Link>
              </Button>
              <Button type="button" variant="outline" asChild>
                <Link to={ROUTES.workOrderInbound(id)}>返回詳情</Link>
              </Button>
            </div>
          </div>

          {isLoading ? (
            <p className="text-sm text-muted-foreground">載入中…</p>
          ) : null}

          {isError ? (
            <p className="text-sm text-destructive">
              {getWorkOrderApiErrorMessage(detailQuery.error, '載入工單失敗')}
            </p>
          ) : null}

          {!isLoading && !isError && detail ? (
            <WorkOrderInboundShell detail={detail} receiptId={receiptId} />
          ) : null}
        </div>
      </div>
    </PageShell>
  );
};

export default WorkOrderInboundPage;
